"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var DigitalProductBadge = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 73 74", fill: "currentColor", width: size || "73", height: size || "74" }, props),
        React.createElement("path", { d: "M43.333,37.25L38,42.14V21H36V42.14l-5.333-4.89-1.333,1.417,7.667,7,7.667-7ZM22,51H52v2H22V51Z", className: "cls-2 content" })));
};
DigitalProductBadge.displayName = 'DigitalProductBadge';
exports.default = DigitalProductBadge;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=DigitalProductBadge.js.map